export default __webpack_public_path__ + "static/media/doc-admin-download.ed036038.svg";